<template>
  <div class="box-description mt-5 mb-5">
	<div class="row">
	  <div class="col-12 col-service-title">
		<h5>Paquetes de MiFi con BlackFon</h5>
	  </div>

	  <div class="col-12 col-benefits">
		<div class="row">
		  <div class="col-12 col-subtitle">
			<h5>Router inalámbrico marca BlackFon que podrás llevar a donde quieras y mantenerte siempre conectado</h5>
		  </div>

		  <div class="col-4 col-sm-6 col-md-4 col-benefit">
			<div class="icons"><i class="fad fa-tachometer"></i></div>
			<p class="txt">Alta velocidad.</p>
		  </div>

		  <div class="col-4 col-sm-6 col-md-4 col-benefit">
			<div class="icons"><i class="fad fa-chart-network"></i></div>
			<p class="txt">Red estable y funcional.</p>
		  </div>

		  <div class="col-4 col-sm-6 col-md-4 col-benefit">
			<div class="icons signal"><i class="fad fa-shield-alt"></i></div>
			<p class="txt">Seguridad en todo momento.</p>
		  </div>

		  <div class="col-12 col-subtitle v2">
			<h5>Conoce nuestros paquetes y contrata ya mismo</h5>
		  </div>
		</div>
	  </div>

	  <offers-slider class="col-12 col-carousel" oferta-tipo="planMifi" />

	</div>
  </div>
</template>

<script>
import offersSlider from "../../daniel/offers-slider.vue"


export default {
  components: { offersSlider }
};
</script>
